import { store } from '..'
import authRoutes from './authRoutes'

export default {

    install(Vue, options) {
        this.router = options.router
        this.router.addRoutes(authRoutes)
        this.queryTokenMiddleWare()
        this.authMiddleware()
        this.langQuery()
    },

    queryTokenMiddleWare() {
        this.router.beforeEach((to, from, next) => {
            let token = to.query.token
            if (token) {
                store.dispatch('auth/setToken', token)
            }
            next()
        })
    },

    authMiddleware() {
        // Before each
        this.router.beforeEach((to, from, next) => {
            if(this.routeRequiresAuth(to)) {
                // Is not logged
                if (!store.getters['auth/isLogged']) {
                    return store.dispatch('auth/shouldLogin', { next, to })
                }

                // Is logged
                store.dispatch('auth/fetchUserIfNecessary').then(() => {

                    // Verify
                    if (!store.getters['auth/passVerification'] && to.name !== 'verify') {
                        return next({
                            name: 'verify',
                            query: {
                                redirect: to.fullPath
                            }
                        })
                    }

                    // Enabled
                    if (!store.getters['auth/passUserEnabled'] && to.name !== 'verify') {
                        return next({
                            name: 'disabled',
                            query: {
                                redirect: to.fullPath
                            }
                        })
                    }

                })
            }
            next()
        })
        // After each
        this.router.afterEach(() => {
            store.dispatch('auth/fetchUserIfNecessary').then(() => {
                store.dispatch('changeLoading', false, { root: true })
            })
        })
    },

    langQuery() {
        // Before each
        this.router.beforeEach((to, from, next) => {
            if (to.query && to.query.lang) {
                store.dispatch('lang/setLanguage', to.query.lang)
            }
            next()
        })
    },

    routeRequiresAuth(to) {
        return to.matched.some(record => record.meta.requiresAuth)
    }

}